import {
  FETCH_STUDENT,
  FETCH_PARENT,
  SET_STUDENT_ACCOUNTS,
  RESET_STUDENT,
  FETCH_CORRECTION_SUMMARIES,
  FETCH_BIO_INFO,
  FETCH_STUDENT_PARAMETERS,
  FETCH_INTERVIEW_LINKS,
  FETCH_INTERVIEW_LINKS_ALL,
  FETCH_INTERVIEW_LINKS_HISTORY,
  FETCH_STUDENT_MEMOS,
  FETCH_STUDENT_ALERTS,
  FETCH_SIGNATURE_ALLOWANCE,
  RESET_SIGNATURE_ALLOWANCE,
  FETCH_STUDENT_PROCESSOR_DOCUMENTS,
  FETCH_COMMENT_CODE_INFOS,
  FETCH_COMMENT_CODE_LINKS,
  FETCH_STUDENT_ATTRIBUTES

} from "../actions/types";

const INITIAL_STATE = {
  student: null,
  parent: null,
  hasAccount: null,
  studentAccount: null,
  parentAccount: null,
  studentParameters: null,
  correctionSummaries: null,
  studentBio: null,
  interviewLinks: null,
  interviewLinksAll: null,
  interviewLinksHistory: null,
  alerts: null,
  memos: null,
  signatureAllowance: null,
  processorFiles: null,
  CRCodes: null,
  commentCodeLinks: null,
  commentCodeInfos: null,
  studentAccountLink: null,
  parentAccountLink: null
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_STUDENT:
      return {
        ...state,
        student: action.payload.student,
        hasAccount: action.payload.hasAccount
      };
    case FETCH_PARENT:
      return {
        ...state,
        parent: action.payload
      };
    case FETCH_STUDENT_ALERTS:
      return {
        ...state,
        alerts: action.payload,
      };
    case FETCH_STUDENT_MEMOS:
      return {
        ...state,
        memos: action.payload,
      };
    case SET_STUDENT_ACCOUNTS:
      return {
        ...state,
        studentAccount: action.payload.studentAccount,
        parentAccount: action.payload.parentAccount,
        otherParentAccount: action.payload.otherParentAccount,
        spouseAccount: action.payload.spouseAccount,
        studentAccountLink: action.payload.studentAccountLink, 
        parentAccountLink: action.payload.parentAccountLink,
        otherParentAccountLink: action.payload.otherParentAccountLink,
        spouseAccountLink: action.payload.spouseAccountLink
      };
    case RESET_STUDENT:
      return {
        ...state,
        student: null,
        parent: null,
        hasAccount: null,
        studentAccount: null,
        parentAccount: null,
        studentParameters: null,
        correctionSummaries: null,
        studentBio: null,
        interviewLinks: null,
        interviewLinksAll: null,
        interviewLinksHistory: null,
        alerts: null,
        memos: null,
        signatureAllowance: null,
        processorFiles: null,
        CRCodes: null,
        commentCodeLinks: null,
        commentCodeInfos: null,
        studentAccountLink: null,
        parentAccountLink: null
      };
    case FETCH_CORRECTION_SUMMARIES:
      return {
        ...state,
        correctionSummaries: action.payload
      };
    case FETCH_BIO_INFO:
      return {
        ...state,
        studentBio: action.payload
      };
    case FETCH_STUDENT_PARAMETERS:
      return {
        ...state,
        studentParameters: action.payload
      };
    case FETCH_STUDENT_PROCESSOR_DOCUMENTS:
      return {
        ...state,
        processorFiles: action.payload
      };
    case FETCH_INTERVIEW_LINKS:
      return {
        ...state,
        interviewLinks: action.payload
      };
    case FETCH_INTERVIEW_LINKS_ALL:
      return {
        ...state,
        interviewLinksAll: action.payload
      };
    case FETCH_INTERVIEW_LINKS_HISTORY:
      return {
        ...state,
        interviewLinksHistory: action.payload
      };
    case FETCH_SIGNATURE_ALLOWANCE:
      return {
        ...state,
        signatureAllowance: action.payload
      };
    case RESET_SIGNATURE_ALLOWANCE:
      return {
        ...state,
        signatureAllowance: null
      };
    case FETCH_COMMENT_CODE_INFOS:
      return {
        ...state,
        commentCodeInfos: action.payload
      };
    case FETCH_COMMENT_CODE_LINKS:
      return {
        ...state,
        commentCodeLinks: action.payload
      };
    case FETCH_STUDENT_ATTRIBUTES:
      return {
        ...state,
        studentAttributes: action.payload
      };
    default:
      return state;
  }
};
